const stripeJs = require('@stripe/stripe-js');

( async function (a) {

    const $paymentMethodForm = a('#modal-add-payment-method');

    if (!!$paymentMethodForm.length) {
        const stripe = await stripeJs.loadStripe(window.Spikkl.stripe_public_key);

        const $creditCardField = $paymentMethodForm.find('#credit-card');
        const $creditCardHolder = $paymentMethodForm.find('#credit-card-owner');
        const $submitButton = $paymentMethodForm.find("[type=submit]");

        const elements = stripe.elements();

        const creditCard = elements.create('card');
        creditCard.mount($creditCardField.get(0));

        $submitButton.on('click', (event) => {
            event.preventDefault();
            $submitButton.addClass('is-loading');

            let method = {
                type: 'card',
                card: creditCard,
                billing_details: {
                    name: $creditCardHolder.val()
                }
            };

            stripe.createPaymentMethod(method).then( (response) => {
                if (response.error) {
                    $submitButton.removeClass('is-loading');
                } else {
                    $paymentMethodForm.find('#payment-method').val(response.paymentMethod.id);
                    $paymentMethodForm.find('form').submit();
                }
            });
        });
    }
}(jQuery));
